export enum CostType {
    NONE = 0,
    COST_TIME = 1,
    COST_CENTIMETER = 2
}